import LifeTimeRewardPageContainer from "../../Component/Reward/LifeTimeReward/LifeTimeReward"

const LifeTimeRewardPage = () => {
  return (
    <div className='page-body'>
      <LifeTimeRewardPageContainer />
    </div>
  )
}

export default LifeTimeRewardPage